<!--  -->
<template>
  <div class=''>

    <el-row type="flex"
            class="row-bg">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <span>轻包装产品</span>
            <!-- <el-button style="float: right; padding: 3px 0"
                       type="text"
                       @click="editProductInfoDialogVisible = true">
              编辑</el-button> -->
          </div>

          <div class='content entry-content'>

            <!-- <div class="product-introduce">
              {{productHtml}}
            </div> -->
            <table class="easyTB temp03">
              <tbody>
                <tr>
                  <th class="easyTBth01">封緘方法</th>
                  <th class="easyTBth02">分類</th>
                  <th class="easyTBth03">機種</th>
                </tr>
                <tr v-for="(item, index) in ds"
                    :key="index">
                  <td class="easyTBcenter t-content"
                      :rowspan="item.row === undefined? 0:item.row"
                      v-if="item.frist"
                      @mouseenter="inGroup(item.pics)"
                      @mouseleave="leaveGroup(item.pics)">
                    <img :src="pic"
                         v-for="(pic, pi) in item.pics.src">
                    <div class="t-action"
                         v-if="item.pics.in">
                      <a @click="doEditPPF(item)">编辑</a>
                      <a>删除</a>
                    </div>
                  </td>
                  <td v-if="!item.isAdd "
                      class="t-content"
                      @mouseenter="inGroup(item)"
                      @mouseleave="leaveGroup(item)">
                    {{item.pGName}}
                    <div class="t-action"
                         v-if="item.in">
                      <a @click="editPPGObj = JSON.parse(JSON.stringify(item));editFengkouTypeDialogVisible = true;">编辑</a>
                      <a>删除</a>
                    </div>
                  </td>
                  <td v-if="item.isAdd">

                    <div class="Item-add">
                      <a @click="editFengkouTypeDialogVisible = true;editPPGObj={pPgId:item.pPgId};fenKous=[]">-
                        新增轻包装类型
                        -</a>
                    </div>
                  </td>
                  <td>
                    <ul class="easyUl">
                      <li v-for="(p,pi) in item.ps">
                        <div class="t-content"
                             @mouseenter="inGroup(p)"
                             @mouseleave="leaveGroup(p)">
                          <a>{{p.pName}}</a>
                          <div class="product-action"
                               v-if="p.in">
                            <a @click="getProductContent(p)">编辑</a><a @click="delP(p)">删除</a>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="Item-add"
                             v-if="!item.isAdd">
                          <a @click="editLPProductDialogVisible = true;editPObj={p:{pGLink:item.pGLink},content:''};">-
                            新增轻包装产品 -</a>
                        </div>
                      </li>
                    </ul>
                  </td>
                </tr>

                <tr class="text-align:center;">
                  <div class="Item-add">
                    <a @click="editFengkouDialogVisible = true;editPPFPics1='';editPPFPics2='';editPPFObj={}">-
                      新增轻包装密封方法 -</a>
                  </div>
                </tr>

              </tbody>
            </table>

          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog title="新增密封方法"
               :visible.sync="editFengkouDialogVisible"
               width="1070px">
      <el-form>
        <el-form-item label="图片1"
                      label-width="180px"
                      label-position="left">
          <el-input autocomplete="off"
                    clearable
                    v-model="editPPFPics1"></el-input>
        </el-form-item>
        <el-form-item label="图片2"
                      label-width="180px">
          <el-input autocomplete="off"
                    clearable
                    v-model="editPPFPics2"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editFengkouDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="editPPF">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增密封类型"
               :visible.sync="editFengkouTypeDialogVisible"
               width="1070px">
      <el-form>
        <el-form-item label="名称"
                      label-width="180px"
                      label-position="left">
          <el-input autocomplete="off"
                    clearable
                    v-model="editPPGObj.pGName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editFengkouTypeDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="editPPG">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增轻包装产品"
               :visible.sync="editLPProductDialogVisible"
               width="1070px">

      <el-row :gutter="20"
              style="align-items: center; line-height: 40px;margin-bottom: 20px;">
        <el-col :span="3"
                style="text-align: right;">
          产品名称
        </el-col>
        <el-col :span="5">
          <el-input placeholder="请输入内容"
                    v-model="editPObj.p.pName"
                    clearable>
          </el-input>
        </el-col>

        <el-col :span="3"
                style="text-align: right;">
          产品路由名称
        </el-col>
        <el-col :span="5">
          <el-input placeholder="请输入内容"
                    v-model="editPObj.p.pLink"
                    clearable>
          </el-input>
        </el-col>

        <el-col :span="3"
                style="text-align: right;">
          密封方法
        </el-col>

        <el-select v-model="fenKous"
                   multiple
                   placeholder="请选择">
          <el-option v-for="item in pFenkous"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-row>

      <el-row :gutter="20"
              style="align-items: center; line-height: 40px;margin-bottom: 20px;">
        <el-col :span="3"
                style="text-align: right;">
          用途
        </el-col>
        <el-col :span="21">
          <el-input placeholder="请输入内容"
                    v-model="editPObj.p.pUse"
                    clearable>
          </el-input>
        </el-col>
      </el-row>

      <el-row :gutter="20"
              style="align-items: center; line-height: 40px;margin-bottom: 20px;">
        <el-col :span="3"
                style="text-align: right;">
          产品图片地址
        </el-col>
        <el-col :span="21">
          <el-input placeholder="请输入内容"
                    v-model="editPObj.p.pPic"
                    clearable>
          </el-input>
        </el-col>
      </el-row>

      产品详情

      <editor :api-key="editorConf.kkey"
              :init="editorConf"
              v-model="editPObj.content"></editor>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editLPProductDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="editPP">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="轻包装产品简介"
               :visible.sync="editProductInfoDialogVisible"
               width="1050px">
      <el-form>
        <el-form-item label="轻包装产品简介"
                      label-width="180px">
          <el-input autocomplete="off"
                    clearable
                    v-model="productHtml"
                    type="textarea"
                    rows="5"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editProductInfoDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="uploadHtmlProduct">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

var Editor = require("@tinymce/tinymce-vue").default;
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    editor: Editor // <- Important part
  },
  data() {
    //这里存放数据
    return {
      productHtml: "",
      editProductInfoDialogVisible: false,
      fenKous: [],
      pFenkous: [
        {
          value: "1",
          label: "Cielo无尽"
        },
        {
          value: "2",
          label: "密封带"
        },
        {
          value: "3",
          label: "贴纸脚踩"
        },
        {
          value: "4",
          label: "装订 - 胶带"
        },
        {
          value: "5",
          label: "装订 -  Binitai"
        },
        {
          value: "6",
          label: "装订 -  抽绳"
        },
        {
          value: "7",
          label: "装订 -  扇形"
        }
      ],
      editPObj: {
        p: {},
        content: ""
      },
      editPPFPics1: "",
      editPPFPics2: "",
      editPPGObj: {},
      editPPFObj: {},
      selectPPF: {},
      editFengkouDialogVisible: false,
      editLPProductDialogVisible: false,
      editFengkouTypeDialogVisible: false,
      newDatas: [],
      ds: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    delP(p) {
      var that = this;
      this.$alert("是否删除该产品", "提示", {
        confirmButtonText: "确定",
        callback: action => {
          if (action == "confirm") {
            var url = "/api/admin/product/delP";
            this.$request.post({
              url: url,
              params: p,
              callback: {
                success: function(data) {
                  that.initDs(data.data);
                },
                err: function(err) {
                  console.log(err);
                }
              }
            });
          }
        }
      });
    },
    uploadHtmlProduct() {
      var that = this;
      this.$request.post({
        url: "/api/admin/cover/pproduct_t",
        params: { html: that.productHtml },
        callback: {
          success: function(data) {
            that.editProductInfoDialogVisible = false;
            that.productHtml = data.data;
          },
          err: function(err) {
            console.log(err);
          }
        }
      });
    },
    doEditPPF(ppf) {
      if (ppf.pics !== undefined && ppf.pics.src !== undefined) {
        if (ppf.pics.src.length > 1) {
          this.editPPFPics2 = ppf.pics.src[1];
        }
        if (ppf.pics.src.length > 0) {
          this.editPPFPics1 = ppf.pics.src[0];
        }
      }
      this.editPPFObj = {
        pGId: ppf.pPgId
      };
      this.editFengkouDialogVisible = true;
    },
    editPPG() {
      var that = this;
      var url = "";
      if (that.editPPGObj.pGId == undefined) {
        url = "/api/admin/product/addPPg";
      } else {
        url = "/api/admin/product/editPPg";
      }
      this.$request.post({
        url: url,
        params: that.editPPGObj,
        callback: {
          success: function(data) {
            if (that.editFengkouTypeDialogVisible) {
              that.editFengkouTypeDialogVisible = false;
              that.initDs(data.data);
            }
          },
          err: function(err) {}
        }
      });
    },
    editPPF() {
      var that = this;
      var url = "";
      if (that.editPPFObj.pGId == undefined) {
        url = "/api/admin/product/addPPF";
      } else {
        url = "/api/admin/product/editPPF";
      }
      that.editPPFObj.pGPic = "";
      if (that.editPPFPics1 !== "") {
        that.editPPFObj.pGPic = that.editPPFObj.pGPic + that.editPPFPics1 + ",";
      }
      if (that.editPPFPics2 !== "") {
        that.editPPFObj.pGPic = that.editPPFObj.pGPic + that.editPPFPics2 + ",";
      }
      this.$request.post({
        url: url,
        params: that.editPPFObj,
        callback: {
          success: function(data) {
            if (that.editFengkouDialogVisible) {
              that.editFengkouDialogVisible = false;
              that.initDs(data.data);
            }
          },
          err: function(err) {}
        }
      });
    },
    getProductContent(product) {
      var that = this;
      this.editPObj.content = "";
      this.$request.get({
        url: "/api/pageData/product/content",
        params: { pLink: product.pLink, pGLink: product.pGLink },
        callback: {
          success: function(data) {
            that.editLPProductDialogVisible = true;
            that.editPObj = data.data;
            that.fenKous = data.data.p.pFenkou.split(",");
          },
          err: function(err) {
            console.log(err);
          }
        }
      });
    },
    editPP() {
      var that = this;
      var url = "";
      if (that.editPObj.p.pId == undefined) {
        url = "/api/admin/product/addPP";
      } else {
        url = "/api/admin/product/editP";
      }
      that.editPObj.p.pFenkou = that.fenKous.join(",");
      // fenKous
      this.$request.post({
        url: url,
        params: that.editPObj,
        callback: {
          success: function(data) {
            that.editLPProductDialogVisible = false;
            that.initDs(data.data);
          },
          err: function(err) {
            console.log(err);
          }
        }
      });
    },
    initDs(rs) {
      var list = [];
      for (var i = 0, len = rs.length; i < len; i++) {
        var df = rs[i];
        if (df.pgs === undefined || df.pgs.length === 0) {
          list.push({
            row: 1,
            pPgId: df.pGId,
            frist: true,
            isAdd: true,
            in: false,
            pics: {
              src: df.pGPic.split(","),
              in: false
            }
          });
        } else {
          for (var j = 0, len2 = df.pgs.length; j < len2; j++) {
            var pg = df.pgs[j];
            if (j === 0) {
              this.$set(pg, "pics", {
                src: df.pGPic.split(","),
                in: false
              });
              this.$set(pg, "frist", true);
            }
            this.$set(pg, "row", len2 + 1);
            list.push(pg);
          }
          list.push({
            pPgId: df.pGId,
            frist: false,
            isAdd: true
          });
        }
      }
      this.ds = list;
    },
    inGroup(obj) {
      obj.in = true;
    },
    leaveGroup(obj) {
      obj.in = false;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var that = this;
    this.$request.get({
      url: "/api/pageData/pProduct",
      callback: {
        success: function(data) {
          that.initDs(data.data.ds);
          that.productHtml = data.data.pproduct;
        },
        err: function(err) {
          console.log(err);
        }
      }
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
.entry-content table {
  border: 0;
  margin: 0;
}

.easyTB {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  empty-cells: show;
}

.entry-content table.temp03 th,
table.temp03 th {
  line-height: 35px;
  height: 35px;
  border: #b0bec5 1px solid;
  font-size: 95%;
  letter-spacing: normal;
  background: #d6dae4;
  display: table-cell;
  text-align: center;
  color: #314478;
  font-weight: bold;
  vertical-align: middle;
}

.easyTB th.easyTBth01 {
  width: 40%;
}

.easyTB th.easyTBth02 {
  width: 20%;
}

.easyTB th.easyTBth03 {
  width: 260px;
}

.entry-content table.temp03 .easyTBcenter {
  text-align: center;
}

.entry-content table.temp03 td {
  padding: 5px;
  vertical-align: middle;
}

.entry-content table.temp03 td,
table.temp03 td {
  border: #b0bec5 1px solid;
  font-size: 90%;
  letter-spacing: normal;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}

.entry-content table.temp03 td {
  padding: 5px;
  vertical-align: middle;
}

.entry-content table.easyTB td {
  text-align: left;
}

.easyUl li {
  line-height: 1.2;
  list-style-position: inside;
  word-break: keep-all;
  padding-top: 2px;
  padding-bottom: 2px;
}

.easyUl li a {
  color: #ff5900;
}

.Item-add {
  padding: 5px !important;
}

.Item-add a {
  color: cornflowerblue !important;
}

.t-content {
  position: relative;
  padding: 2px;
}

.t-action {
  position: absolute;
  top: 0;
  right: 0px;
}

.t-action a {
  padding: 3px;
  color: cornflowerblue;
  cursor: pointer;
}

.product-action {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 2px;
  text-align: center;
  background-color: rgba($color: #000000, $alpha: 0.5);
}

.product-action a {
  color: white !important;
  margin-left: 5px;
  cursor: pointer;
}

.el-col-21 .el-select {
  width: 100%;
}
</style>